/* global API */

import { createApp } from 'vue';
import Paginate from 'vuejs-paginate-next';
import { directive } from 'vue3-click-away';
import {
	useQuery,
	useGetTitle,
	useGetShortDesc,
	useGetDesc,
	useHasShortDesc,
	useGetHref,
	useGetOPS,
	useFormatDate,
	useFormatEventDate,
	useFormatEventDateWithTime,
	useGetParams,
} from './composables/data';

import {
	useGetMaterialRelevance,
	useFindParent,
	useFindAllParents,
	useFindAllChildren,
	useCreateRelevancyString,
	useGetGreencomp,
	useGroupSubjects,
	useCreateLaajaOptions,
	useGetLaajaSlugs,
	useGetGcBySlug,
} from './composables/greencomp';

import { useGetSubjects } from './composables/subjects';

// Vue element
const vueSelector = '.mappa-cards';
const vueElement = document.querySelector(vueSelector);

if (vueElement) {
	const app = createApp({
		directives: {
			ClickAway: directive,
		},
		components: {
			Paginate,
		},
		data() {
			return {
				lang: 'fi',
				postType: 'materiaalit',
				results: {},
				loading: false,
				embed: true,
				useQuery,
				tab: '',
				showPostType: false,
				data: {
					keywords: [],
					subjects: [],
					laajas: [],
					laajaRelated: [],
					ops: {},
					classTerms: [],
					subjectTerms: [],
					groupedSubjects: [],
				},
				helpers: {
					showKeywords: false,
					keyword: '',
					loading: false,
					subjectObject: {
						subject: '',
						subject_class: '',
						subject_target: '',
						subject_lang: '',
						subject_area: '',
					},
					greencomp: {
						first: '',
						second: '',
						third: '',
					},
					laajaObject: {
						tavoite: '',
						oppiaine: '',
						vuosiluokka: '',
					},
				},
				weird_ones: ['Äidinkieli ja kirjallisuus', 'Toinen kotimainen kieli', 'Vieraat kielet'],
				weird_ones_lukio: ['Äidinkieli ja kirjallisuus'],
			};
		},
		async mounted() {
			this.loading = true;

			this.useQuery.posts_per_page = 5;

			// Check if we have laaja_query, ops_query or gc_query
			const url = new URL(window.location.href);

			if (url.searchParams.has('tab')) {
				const tab = url.searchParams.get('tab');

				const opsPromise = this.useGetOPS(true);
				const greencompPromise = this.useGetGreencomp();
				const subjectsPromise = this.useGetSubjects();

				await Promise.all([opsPromise, greencompPromise, subjectsPromise]);

				this.useGetParams();

				this.useGroupSubjects();
				this.useCreateLaajaOptions();
				this.useQuery.taxonomies = true;

				if (tab === 'laaja') {
					this.useQuery.laajahaku = true;
					const { tavoite, oppiaine, vuosiluokka } = this.helpers.laajaObject;

					const slugs = this.useGetLaajaSlugs(tavoite);

					this.useQuery.tax_query.laaja_tavoite = slugs;
					this.useQuery.tax_query.laaja_oppiaine = oppiaine;
					this.useQuery.tax_query.laaja_vuosiluokka = this.data.classTerms[vuosiluokka]?.terms;

					this.useQuery.tax_query.laaja_tavoite_query = tavoite;
					this.useQuery.tax_query.laaja_oppiaine_query = oppiaine;
					this.useQuery.tax_query.laaja_vuosiluokka_query = vuosiluokka;
				} else if (tab === 'ops') {
					const subjectArray = new Map(Object.entries(this.helpers.subjectObject));
					const slugs = [];

					subjectArray.forEach((item) => {
						if (item) {
							slugs.push(item.slug);
						}
					});

					this.useQuery.tax_query.soveltuvuudet = slugs;
					this.useQuery.and = true;
					this.useQuery.order = 'desc';
				} else if (tab === 'gc') {
					const gcArray = new Map(Object.entries(this.helpers.greencomp));
					const slugs = [];

					gcArray.forEach((item) => {
						if (item) {
							slugs.push(item.slug);
						}
					});

					this.useQuery.tax_query.greencomp = slugs;
					this.useQuery.and = true;
				}

				this.useQuery.tab = this.tab;
			} else {
				this.useGetParams();
			}

			if (this.postType === 'all') {
				this.showPostType = true;
			}

			this.search();
		},
		methods: {
			/**
			 * Hakufunktio
			 * @param {boolean} log Logataanko hakukysely
			 */
			search(log = false) {
				this.useQuery.log = log;

				fetch(`${API.url}/search`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'X-WP-Nonce': API.nonce,
					},
					body: JSON.stringify(this.useQuery),
				})
					.then((res) => res.json())
					.then((response) => {
						this.results[this.postType] = response;
					})
					.catch((error) => console.error('Error', error))
					.finally(() => {
						this.loading = false;
					});
			},
			useGetTitle,
			useGetShortDesc,
			useGetDesc,
			useHasShortDesc,
			useGetHref,
			useGetMaterialRelevance,
			useFindParent,
			useFindAllParents,
			useFindAllChildren,
			useCreateRelevancyString,
			useGetOPS,
			useGetGreencomp,
			useGetSubjects,
			useGroupSubjects,
			useCreateLaajaOptions,
			useGetLaajaSlugs,
			useGetGcBySlug,
			useFormatDate,
			useFormatEventDate,
			useFormatEventDateWithTime,
			useGetParams,
		},
	});

	app.mount(vueSelector);
}
